import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../common/filters.component';

@Component({
	selector: 'app-leads-list-filters',
	templateUrl: './leads-list-filters.component.html',
	styleUrls: ['./leads-list-filters.component.css'],
})
export class LeadsListFiltersComponent extends FiltersComponent {
	filters = {
		search: null,
		date_from: null,
		date_to: null,
		update_date_from: null,
		update_date_to: null,
		status: null,
		type: null,
		owner: null,
	};
	@Input() statuses: Array<any>;
	@Input() types: Array<any>;
	@Input() users: Array<any>;
}
